// Centralised data-testids for Pickle Wall
export const NAV = {
  logo: "nav-logo",
  link: (name) => `nav-link-${name}`,
  ctaPreorder: "nav-cta-preorder",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  primaryCta: "hero-cta-preorder",
  secondaryCta: "hero-cta-watch-demo",
  stat: (k) => `hero-stat-${k}`,
};

export const PRODUCT = {
  feature: (k) => `product-feature-${k}`,
};

export const BENEFIT = {
  card: (k) => `benefit-card-${k}`,
};

export const APP_SEC = {
  feature: (k) => `app-feature-${k}`,
};

export const TESTIMONIAL = {
  card: (i) => `testimonial-card-${i}`,
};

export const FAQ = {
  item: (i) => `faq-item-${i}`,
};

export const LEAD = {
  form: "lead-form",
  name: "lead-name",
  email: "lead-email",
  phone: "lead-phone",
  submit: "lead-submit",
};

export const INQUIRY = {
  form: "inquiry-form",
  name: "inquiry-name",
  email: "inquiry-email",
  phone: "inquiry-phone",
  org: "inquiry-organization",
  orgType: "inquiry-organization-type",
  cityState: "inquiry-city-state",
  units: "inquiry-units",
  message: "inquiry-message",
  submit: "inquiry-submit",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
};

export const PREORDER = {
  form: "preorder-form",
  name: "preorder-name",
  email: "preorder-email",
  phone: "preorder-phone",
  qty: "preorder-quantity",
  variant: "preorder-variant",
  submit: "preorder-submit",
};

export const VIDEO_GALLERY = {
  section: "video-gallery-section",
  playButton: "video-gallery-play-button",
  videoFrame: "video-gallery-frame",
  galleryItem: (i) => `video-gallery-item-${i}`,
  lightbox: "video-gallery-lightbox",
  lightboxClose: "video-gallery-lightbox-close",
  expandedPanel: "video-gallery-expanded-panel",
  expandedHeadline: "video-gallery-expanded-headline",
  expandedDescription: "video-gallery-expanded-description",
  expandedCategory: (cat) => `video-gallery-expanded-category-${cat.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`,
  expandedTag: (tag) => `video-gallery-expanded-tag-${tag.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`,
};

export const SHOP = {
  card: (id) => `shop-card-${id}`,
  buy: (id) => `shop-buy-${id}`,
  color: (c) => `shop-color-${c}`,
  size: (s) => `shop-size-${s}`,
  qtyDecrease: "shop-paddle-qty-decrease",
  qtyIncrease: "shop-paddle-qty-increase",
  anchorNav: (id) => `shop-anchor-nav-${id}`,
  faqItem: (i) => `shop-faq-item-${i}`,
  galleryThumb: (k) => `hoodie-gallery-thumb-${k}`,
  galleryMain: "hoodie-gallery-main-image",
  galleryZoom: "hoodie-gallery-zoom-button",
  galleryLightbox: "hoodie-gallery-lightbox",
};

export const CART = {
  trigger: "cart-trigger",
  drawer: "cart-drawer",
  checkout: "cart-checkout-button",
  discountInput: "cart-discount-input",
  discountApply: "cart-discount-apply",
  discountRemove: "cart-discount-remove",
  discountActive: "cart-discount-active",
  discountAmount: "cart-discount-amount",
  total: "cart-total",
};

export const BUNDLE = {
  card: (id) => `bundle-card-${id}`,
  addAll: (id) => `bundle-add-all-${id}`,
};

export const TRUST = {
  badge: (id) => `shop-trust-badge-${id}`,
};

export const COMPARE = {
  row: (id) => `shop-compare-row-${id}`,
};

export const SIZE_GUIDE = {
  trigger: "hoodie-size-guide-trigger",
  modal: "hoodie-size-guide-modal",
  close: "hoodie-size-guide-close",
  contactLink: "hoodie-size-guide-contact-link",
};

export const SAVE_CART = {
  toggle: "save-cart-toggle",
  email: "save-cart-email",
  marketingConsent: "save-cart-marketing-consent",
  submit: "save-cart-submit",
};

export const PRO48 = {
  launchEmail: "pro48-launch-email",
  launchName: "pro48-launch-name",
  launchSubmit: "pro48-launch-submit",
};

export const ADMIN = {
  password: "admin-password",
  login: "admin-login",
  logout: "admin-logout",
  tab: (k) => `admin-tab-${k}`,
};
